export const BRAND = {
  name: "Groupe Huvig",
  short: "GHV",
  tagline: "Achat · Vente · Revente Automobile",
  city: "Chalon-sur-Saône",
  address: "Bâtiment A, 1 Rue du Lieutenant André, 71100 Chalon-sur-Saône",
  siren: "100 073 378",
};

export const PHONE_DISPLAY = "07 58 29 28 34";
export const PHONE_TEL = "+33758292834";
export const WHATSAPP_URL = "https://wa.me/33758292834";

export const whatsappVehicleUrl = (label) =>
  `${WHATSAPP_URL}?text=${encodeURIComponent(`Bonjour Groupe Huvig, je suis intéressé par le véhicule ${label}. Est-il toujours disponible ?`)}`;

export const SOCIALS = [
  { platform: "Instagram", url: "https://instagram.com/groupehuvig", icon: "instagram", label: "Suivez-nous sur Instagram" },
  { platform: "Facebook", url: "/contact", icon: "facebook", label: "Contactez-nous (Facebook bientôt disponible)" },
  { platform: "TikTok", url: "https://tiktok.com/@groupehuvig", icon: "tiktok", label: "Vidéos TikTok GHV" },
  { platform: "Snapchat", url: "https://snapchat.com/add/VHUVIG", icon: "snapchat", label: "Snapchat GHV" },
  { platform: "WhatsApp", url: WHATSAPP_URL, icon: "whatsapp", label: "Discutez en direct sur WhatsApp" },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1776102668992-87c62534c475?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBzcG9ydHMlMjBjYXIlMjBzaG93cm9vbSUyMGJsYWNrJTIwcmVkfGVufDB8fHx8MTc4ODcyNjYzOHww&ixlib=rb-4.1.0&q=85";

export const fmtPrice = (n) => `${new Intl.NumberFormat("fr-FR").format(n)} €`;
export const fmtKm = (n) => `${new Intl.NumberFormat("fr-FR").format(n)} km`;

export const STATUS_LABELS = { disponible: "Disponible", reserve: "Réservé", vendu: "Vendu" };
export const STATUS_COLORS = {
  disponible: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  reserve: "bg-amber-500/15 text-amber-400 border-amber-500/30",
  vendu: "bg-red-500/15 text-red-400 border-red-500/30",
};
